// assets
import {
  IconBoxMultiple,
  IconDevices2,
  IconUsersGroup,
  IconUser,
} from '@tabler/icons-react';

// constant
const icons = {
  IconBoxMultiple,
  IconDevices2,
  IconUsersGroup,
  IconUser,
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const quotations = {
  id: 'quotations',
  title: 'Quotation Management',
  type: 'group',
  access: ['super_admin', 'admin', 'user'],
  children: [
    {
      id: 'quotations',
      title: 'Quotations',
      type: 'collapse',
      color: '#2F0F5D',
      icon: icons.IconBoxMultiple,
      access: ['super_admin', 'admin', 'user'],
      children: [
        {
          id: 'all-quotations',
          title: 'All Quotations',
          type: 'item',
          url: '/quotations/quotations/all-quotations',
          access: ['super_admin', 'admin', 'user'],
        },
        {
          id: 'draft-quotations',
          title: 'Draft Quotations',
          type: 'item',
          url: '/quotations/quotations/draft-quotations',
          access: ['super_admin', 'admin', 'user'],
        },
        {
          id: 'sent-to-client',
          title: 'Sent To Client',
          type: 'item',
          url: '/quotations/quotations/sent-to-client',
          access: ['super_admin', 'admin', 'user'],
        },
        {
          id: 'accepted',
          title: 'Accepted',
          type: 'item',
          url: '/quotations/quotations/accepted',
          access: ['super_admin', 'admin', 'user'],
        },
        {
          id: 'declined',
          title: 'Declined',
          type: 'item',
          url: '/quotations/quotations/declined',
          access: ['super_admin', 'admin', 'user'],
        },
        {
          id: 'analyze-declined',
          title: 'Analyze Declined',
          type: 'item',
          url: '/quotations/quotations/analyze-declined',
          access: ['super_admin', 'admin', 'user'],
        },
      ],
    },
    {
      id: 'product-management',
      title: 'Product Management',
      type: 'collapse',
      color: '#2F0F5D',
      icon: icons.IconDevices2,
      access: ['super_admin', 'admin', 'user'],
      children: [
        {
          id: 'product-list',
          title: 'Product List',
          type: 'item',
          url: '/quotations/product-management/product-list',
          access: ['super_admin', 'admin', 'user'],
        },
        {
          id: 'discontinued-products',
          title: 'Discontinued Products',
          type: 'item',
          url: '/quotations/product-management/discontinued-products',
          access: ['super_admin', 'admin', 'user'],
        },
        {
          id: 'brand-list',
          title: 'Brand List',
          type: 'item',
          url: '/quotations/product-management/brand-list',
          access: ['super_admin', 'admin', 'user'],
        },
      ],
    },
    {
      id: 'client-management',
      title: 'Client Management',
      type: 'collapse',
      color: '#2F0F5D',
      icon: icons.IconUsersGroup,
      access: ['super_admin', 'admin', 'user'],
      children: [
        {
          id: 'client-list',
          title: 'Client List',
          type: 'item',
          url: '/quotations/client-management/client-list',
          access: ['super_admin', 'admin', 'user'],
        },
        {
          id: 'inactivated-client',
          title: 'Inactivated Clients',
          type: 'item',
          url: '/quotations/client-management/inactivated-clients',
          access: ['super_admin', 'admin', 'user'],
        },
      ],
    },
  ],
};

export default quotations;
